<template>
	<div class="xs-12">
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">{{ $t("source") }}</div>
		</div>

		<!-- Body -->
		<j-card>
			<div class="flex xs-12 p3">
				<div class="flex xs-10 xs-left xs-middle fw7 c6 lh125">
					<j-base-input-text
						ref="input"
						v-if="editMode"
						v-model="source"
						@blur="updateCompany()"
					/>
					<p v-else>{{ entity.source || "----" }}</p>
				</div>
				<div class="flex xs-2 xs-right xs-middle">
					<j-button
						type="tertiary"
						@click="handleUpdate()"
						v-can:or="['writeIndividualContacts', 'writeCompanyContacts']"
					>
						<crm-icon name="edit" color="c6" size="small" />
					</j-button>
					<j-button
						v-if="entity.source"
						type="tertiary"
						@click="handleDelete()"
						v-can="'writeLinks'"
					>
						<crm-icon name="delete" color="cError" size="small" />
					</j-button>
				</div>
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import JBaseInputText from "@/components/JBaseInputText/"
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import gql from "@/api/gql.js"

export default {
	components: { JCard, CrmIcon, JButton, JBaseInputText },
	props: {
		entity: {
			type: Object,
			required: true
		}
	},

	data() {
		return {
			source: "",
			editMode: false
		}
	},

	methods: {
		handleDelete() {
			this.editMode = false
			this.updateSource(null)
		},
		updateCompany() {
			this.editMode = false
			this.updateSource(this.source)
		},
		handleUpdate() {
			this.editMode = true
			this.source = this.entity.source
			this.$nextTick(() => {
				this.$refs.input.focus()
			})
		},
		async updateSource(source) {
			const mutation = `
        mutation updateCompany($id:String!, $updateCompanyInput:updateCompanyInput!){
          updateCompany(id:$id, updateCompanyInput:$updateCompanyInput){
            status
            errors
          }
        }
      `
			const variables = {
				id: this.entity.id,
				updateCompanyInput: {
					source: source
				}
			}
			await gql({
				query: mutation,
				variables
			})
			this.source = null
			this.$emit("input")
		}
	}
}
</script>
